import React from 'react';
import { Typography, makeStyles, Button } from '@material-ui/core';
import { theme } from 'theme';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  addButton: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    padding: '0 12px',
    height: 30,
    borderRadius: 8,
    marginBottom: 10,

    '&:hover': {
      backgroundColor: theme.palette.grey[900],
    },
  },
  addButtonText: {
    textTransform: 'none',
    color: theme.palette.primary.contrastText,
    fontSize: 14,
  },
});

interface SendCodeButtonProps {
  onClick: () => void;
}

function SendCodeButton({ onClick }: SendCodeButtonProps) {
  const classes = useStyles();
  const { t, i18n } = useTranslation();

  return (
    <Button onClick={onClick} className={classes.addButton} variant="contained" color="inherit">
      <Typography className={classes.addButtonText}>
        {t('Send Code')} ({t('SMS verification is required')})
      </Typography>
    </Button>
  );
}

export default SendCodeButton;
